import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FileComponent from '../components/File/FilePreview';
import * as FileActions from '../actions/File';

class File extends Component {

    render() {
        return(
            <FileComponent
                file={this.props.file}
                onCancelButtonClick={this.props.onCancelButtonClick}/> 
        );
    }
}

File.propTypes = {
    file: PropTypes.shape({
        name: PropTypes.string,
        base64: PropTypes.string
    }),
    onCancelButtonClick: PropTypes.func
};

const mapStateToProps = (state) => {
    return{
        file: state.file.selectedFile,
    };
};
   
const mapDispatchToProps = (dispatch) => {
    return {
        onCancelButtonClick : () => dispatch(FileActions.closeFilePreview())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(File);


// WEBPACK FOOTER //
// ./src/containers/File.js